import FileSaver from 'file-saver';
import html2pdf from "html2pdf.js";

export default class ExportModel {
	static removeDivTagsRegE(html){
		let regEx = /<div class="editor_block_render">([\s\S]*?)<\/div>/g;
		return html.replace(regEx, '$1');
	}


	static async  convertImgToBase64(htmlString) {
		const parser = new DOMParser();
		const htmlDoc = parser.parseFromString(htmlString, 'text/html');
		const images = htmlDoc.getElementsByTagName('img');
		for (let img of images) {
			const url = img.src;

			const response = await fetch(url);
			const blob = await response.blob();
			img.className=" ";
			img.style=" ";
			img.alt=" ";
			img.src = await new Promise(resolve => {
				const reader = new FileReader();
				reader.onloadend = () => resolve(reader.result);
				reader.readAsDataURL(blob);
			});
			//img.src='data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg==';

			img.src=img.src.replace("base64,","base64,  ");

		}

		return htmlDoc.documentElement.outerHTML;
	}

	static removeDivs(htmlString) {
		var div = document.createElement('div');
		div.innerHTML = htmlString;
		var elements = div.getElementsByTagName('div');

		while(elements[0]) {
			var parent = elements[0].parentNode;
			while(elements[0].firstChild) {
				parent.insertBefore(elements[0].firstChild, elements[0]);
			}
			parent.removeChild(elements[0]);
		}

		return div.innerHTML;
	}
	static wrapImgWithPTag(htmlString) {
		var div = document.createElement('div');
		div.innerHTML = htmlString;
		var images = div.getElementsByTagName('img');

		for(var i = 0; i < images.length; i++) {
			var parent = images[i].parentNode;
			var wrapper = document.createElement('p');
			parent.replaceChild(wrapper, images[i]);
			wrapper.appendChild(images[i]);
		}

		return div.innerHTML;
	}
	static async start(title,html,footerHTML){
		var app=this;
		var vm=this;

		html=ExportModel.removeDivs(html);
		html=await ExportModel.convertImgToBase64(html);
		//html=ExportModel.wrapImgWithPTag(html);
		html=html+footerHTML;


		var preHtml = "<!DOCTYPE html><html lang='ru'><head><meta charset='utf-8'><title>"+title+"</title></head><body>";
		var postHtml = "</body></html>";

		var htmlData=html;
		htmlData=htmlData.replace("<div","<p");
		htmlData=htmlData.replace("</div>","</p>");

		htmlData=htmlData.replace(/<!--(?:.|\n)*?-->/gm, '');
		htmlData=ExportModel.removeDivTagsRegE(htmlData);
		var html = preHtml+htmlData+postHtml;

		// app.Export2Word(htmlData,title);



		var worker = html2pdf().from(html).save(title);

		// const fileBuffer = await HTMLtoDOCX(html, null, {
		// 	table:{row:{cantSplit:true}},
		// 	footer:true,
		// 	pageNumber:true,
		//
		// 	margins:{
		// 		top:1440,
		// 		left:1,
		// 		right:1,
		// 		bottom:1440,
		// 		header:720,
		// 		footer:720,
		// 		gutter:0
		// 	},
		// 	decodeUnicode:true,
		//
		// },footerHTML);
		//
		//
		// FileSaver.saveAs(fileBuffer, title+'.docx');
	}
}